import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/shared/services/auth.service';
import { Subscription } from 'rxjs';
import { ManagementTabsService } from './services/management-tabs.service';

@Component({
  selector: 'app-management-tabs',
  templateUrl: './management-tabs.component.html',
  styleUrls: ['./management-tabs.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ManagementTabsComponent implements OnInit {
  managementLinks: any[] = [];
  warning = '';
  managementTabsSubscription: Subscription = new Subscription();

  constructor(public authService: AuthService, public managementTabsService: ManagementTabsService, private _router: Router) {}

  selectedIndex = 0;

  ngOnInit() {
    this.managementLinks = this.getManagementLinks();

    this.managementTabsSubscription = this.managementTabsService.error$.subscribe((val) => (this.warning = val));
  }

  getManagementLinks() {
    const links: { label: string; link: string; index?: number }[] = [
      {
        label: 'Meine persönlichen Daten',
        link: './meine-persönlichen-daten',
      },
    ];

    if (this.authService.permissions.USER_MANAGEMENT) {
      links.push({
        label: 'Benutzerverwaltung',
        link: './benutzerverwaltung',
      });
    }

    if (this.authService.permissions.REGION_MANAGEMENT) {
      links.push({
        label: 'Regionenverwaltung',
        link: './regionenverwaltung',
      });
    }
    if (this.authService.permissions.GENERAL_CONFIGURATION) {
      links.push({
        label: 'Kommunenverwaltung',
        link: './kommunenverwaltung',
      });
    }

    if (this.authService.permissions.RELEASE_NOTE_ADMIN) {
      links.push({
        label: 'Neuerungen verwalten',
        link: './neuerungen-verwalten',
      });
    }

    if (this.authService.permissions.KOMMUNEN_ONBOARDING) {
      links.push({
        label: 'Kommunen-Onboarding',
        link: './kommunen-onboarding',
      });
    }

    links.forEach((link, i) => {
      link['index'] = i;
    });

    return links;
  }

  gotoDashboard() {
    this._router.navigateByUrl('/instrumententafel');
  }

  trackByFn(_: number, item: any) {
    return item.label;
  }
}
